import React from 'react'

function BrandOne() {
    return (
        <div>
            {/* start trusted client section */}
            <div className="rts-trusted-client rts-section-gapBottom">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="title-area-client text-center">
                                <p className="client-title">Nos partenaires</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                            <a href="#" className="d-block">
                                <img src="assets/images/partenaire1.jpeg" alt="business_finbiz" className="partner-img" />
                            </a>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                            <a href="#" className="d-block">
                                <img src="assets/images/partenaire2.jpeg" alt="business_finbiz" className="partner-img" />
                            </a>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                            <a href="#" className="d-block">
                                <img src="assets/images/partenaire3.jpeg" alt="business_finbiz" className="partner-img" />
                            </a>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                            <a href="#" className="d-block">
                                <img src="assets/images/partenaire4.jpeg" alt="business_finbiz" className="partner-img" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            {/* end trusted client section */}

        </div>
    )
}

export default BrandOne